import React from 'react';
import { Card, Form, Switch, List, Typography } from 'antd';

const { Text } = Typography;

const NotificationSettings = () => {
  const data = [
    {
      title: 'Email Notifications',
      description: 'Receive emails about important updates and alerts.',
    },
    {
      title: 'SMS Notifications',
      description: 'Receive SMS alerts for urgent matters.',
    },
    {
      title: 'System Announcements',
      description: 'Receive notifications about system maintenance and new features.',
    },
  ];

  return (
    <Card title="Notification Preferences" bordered={false}>
      <List
        itemLayout="horizontal"
        dataSource={data}
        renderItem={(item) => (
          <List.Item
            actions={[<Switch defaultChecked />]}
          >
            <List.Item.Meta
              title={item.title}
              description={item.description}
            />
          </List.Item>
        )}
      />
    </Card>
  );
};

export default NotificationSettings;
